import { useCurrentLessonStore } from '@stores/useCurrentLessonStore'

export function useCurrentLesson() {
  const currentLesson = useCurrentLessonStore((state) => state.currentLesson)
  const setCurrentLesson = useCurrentLessonStore(
    (state) => state.setCurrentLesson,
  )

  return {
    currentLesson,
    setCurrentLesson,
  }
}
